<template>
	<div style="margin: 10px;">
		<el-row>
			<el-col :span="24">
				<el-card class="box-card">
					<el-row>
						<el-col :span="24">
							<el-table row-key="id" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
							 element-loading-background="rgba(0, 0, 0, 0.8)" ref="multipleTable" size="mini" :data="tableData" style="width: 100%" border :header-cell-style="{background:'#E5E7EE',color:'#000000'}">
								<el-table-column type="selection" width="55" align="center">
								</el-table-column>
								<el-table-column align="center" :prop="dropCol[index].prop" :label="item.label"
									v-for="(item,index) in col" :key="`col_${index}`">
								</el-table-column>
								<!-- <el-table-column prop="id" label="编号" align="center" width="55">
								</el-table-column>
								<el-table-column prop="title" label="Banner标题" align="left">
								</el-table-column>
								<el-table-column prop="website" label="链接" align="center">
								</el-table-column> -->
								<el-table-column prop="imagesThumb" label="图片" align="center">
									<template slot-scope="scope">
										<div class="demo-image__preview" @click="preview(scope.row)">
											<img style="width: 80px; height: 80px"
												:src="settings.apiBaseImg+scope.row.images" 	>
										
										</div>
										
										  
									</template>
								</el-table-column>
								
								<el-table-column fixed="right" label="更多操作">
									<template slot-scope="scope">
										<!-- <el-button @click.native.prevent="update('update',scope.row, scope.row)" type="text" size="small">
											编辑
										</el-button>
										<span>|</span>
										<el-button @click.native.prevent="deleteRow(scope.$index, scope.row)" type="text" size="small">
											删除
										</el-button> -->
										<el-button type="success" icon="el-icon-edit" circle  size="small"  @click.native.prevent="update('update',scope.row)"></el-button>
											<el-button type="danger" icon="el-icon-delete" circle  @click.native.prevent="deleteRow(scope.$index,scope.row)"  size="small"></el-button>
										
									</template>
								</el-table-column>
							</el-table>
							<div class="tableFooter">
								<button class="selectAll"  @click="toggleSelection(tableData)" style="float: left;">全选</button>
								<button class="del" @click="del" style="float: left;margin-left: 10px;">批量删除</button>
								<button class="add" @click="update('add')" style="float: left;">新增banner</button>
							</div>
							<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
							size="mini"   :page-sizes="[10, 20, 30, 40]" :page-size="100" layout="total, prev, pager, next, jumper" :total="total">
							</el-pagination>
						</el-col>
					</el-row>

				</el-card>
			</el-col>
		</el-row>
		<fox-preview-image v-model="visiable" :src="srcList" z-index="9000"></fox-preview-image>
	</div>
</template>

<script>
	import qs from 'qs'
	
	export default {
		data() {
			return {
				form: {
					one: '',
					two: '',
					three: ''
				},
				tableData: [],
			currentPage: 1,
			pageSize:10,
			total: 0,
			loading:false,
			srcList:'',
			visiable:false,
			col: [{
					label: '编号',
					prop: 'id'
				},
				{
					label: 'Banner标题',
					prop: 'title'
				},
				{
					label: '链接',
					prop: 'website'
				},{
					label: '栏目',
					prop: 'columns'
				},
			],
			dropCol: [{
					label: '编号',
					prop: 'id'
				},
				{
					label: 'Banner',
					prop: 'title'
				},
				{
					label: '链接',
					prop: 'website'
				},
				{
					label: '栏目',
					prop: 'columns'
				},
			],
			}
		},
		created() {
			this.getData(this.currentPage, this.pageSize)
		},
		mounted() {
			this.rowDrop()
		},
		methods: {
			// 行拖拽
			rowDrop() {
				const tbody = document.querySelector('.el-table__body-wrapper tbody')
				const _this = this
				this.Sortable.create(tbody, {
					onEnd({
						newIndex,
						oldIndex
					}) {
						const currRow = _this.tableData.splice(oldIndex, 1)[0]
						_this.tableData.splice(newIndex, 0, currRow)
					}
				})
			},
			getData(currentPage, pageSize){
				var obj = this;
				obj.$http({
					method: 'get',
					url: 'api/v1/wbanner/page',
					params:{
						 
						pageNum: currentPage,
						pageSize: pageSize,
					},
				}).then((res) => {
					if (res.data.status == 200) {
						this.tableData = res.data.data.data
						this.total = res.data.data.total
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
			update(iden, rows,table) {
				this.$router.push({
					path: '/home/phoneAdd',
					query:{
						rows:rows,
						iden:iden
					}
				})
			},
			//全选
			toggleSelection(rows) {
				if (rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			deleteRow(index, rows) {
				this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					var obj = this;
					obj.$http({
						method: 'get',
						url: 'api/v1/wbanner/delete',
						params: {
							id: rows.id,
						},
					}).then((res) => {
						if (res.status == 200) {
							obj.$message.success('删除成功')
							this.getData(this.currentPage, this.pageSize)
						} else {
							obj.$message.error(res.data.msg)
						}
					})
			
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			
			},
			//批量删除
			del() {
				if (this.$refs.multipleTable.selection.length == 0) {
					this.$message.error('请选择要删除的表格信息！');
					return;
				}
				var list = []
				for (var i = 0; i < this.$refs.multipleTable.selection.length; i++) {
					list.push(this.$refs.multipleTable.selection[i].id)
				}
				this.$confirm('此操作将永久删除所选信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					var obj = this;
					obj.$http({
						method: 'get',
						url: 'api/v1/wbanner/clear',
						params: {
							ids: list.toString(),
							uid: localStorage.getItem('uid')
						},
					}).then((res) => {
						if (res.status == 200) {
							obj.$message.success('删除成功')
							this.getData(this.currentPage, this.pageSize)
						} else {
							obj.$message.error(res.data.msg)
						}
					})
			
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			//分页事件
			handleSizeChange(val) {
				this.pageSize = val; //将每页显示的条数 = 改变的值
				this.getData(this.currentPage, this.pageSize)
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getData(this.currentPage, this.pageSize)
			},
			preview(rows){
				this.visiable = true
				this.srcList = ''
				this.srcList = this.settings.apiBaseImg + rows.images
			}
		},
	}
</script>

<style scoped="scoped">
	/deep/ .el-input__inner {
		height: 40px !important;
	}

	/deep/ .el-form-item__label {
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #000000;
		line-height: 24px;
	}

	/deep/ .el-button--text {
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #7C96F8;
		line-height: 24px;
	}

	span {
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #7C96F8;
		line-height: 24px;
	}

	.chenggong {
		width: 49px;
		height: 16px;
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #000000;
		line-height: 24px;
		opacity: 0.7;
	}

	.fail {
		width: 33px;
		height: 16px;
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #76B67E;
		line-height: 24px;
	}
</style>



// WEBPACK FOOTER //
// src/views/phone/phone/phone.vue